import { css } from '@emotion/react'
import { theme } from '@nexans/react-ui-kit'

export const globalStyles = {
  mainContainer: css({
    position: 'relative',
    width: '100%',
    maxWidth: `calc(${theme.screens.desktop} + 48px)`,
    [theme.breakpoints.minDesktop]: {
      marginInline: 'auto',
    },
  }),
  flexWrap: css({
    flexWrap: 'wrap',
  }),
  flexGrow: css({
    flex: 1,
  }),
}
